import React, { useState, useEffect } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import $, { data } from 'jquery';
import '../pages.css';
const AdAddPage = () => {
  const [loading, setLoadingAddPage] = useState(false); // New state for loading add page
  const [showAddNumberInput, setShowAddNumberInput] = useState(false);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [showFirstInput, setShowFirstInput] = useState(false); // New state for showing the first input
  const [showForm, setShowForm] = useState(false); // State to control the visibility of the form

    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [builderTypes, setBuilderTypes] = useState([]);
  const [selectedBuilderType, setSelectedBuilderType] = useState('');
  const [numbers, setNumbers] = useState(['']);
  const [formData, setFormData] = useState({
    builderName: '',
    facebookPageName: '',
    adID: '',
    whatsAppNumber: '',
    selectedBuilderType:'',
    // Add other fields here
  });

  const toggleForm = () => {
    setShowForm(!showForm);
  };

  const handleAddNumber = () => {
    if (numbers.length < 4) {
      const updatedNumbers = [...numbers, ''];
      setNumbers(updatedNumbers);
    }
  };
  
  const handleRemoveNumber = (index) => {
    const updatedNumbers = [...numbers];
    updatedNumbers.splice(index, 1);
    setNumbers(updatedNumbers);
  };


 

  // const handleAddNumber = () => {
  //   const lastNumber = numbers[numbers.length - 1];
  
  //   if (lastNumber === '') {
  //     const newErrors = { ...errors };
  //     newErrors[`whatsAppNumber${numbers.length}`] = 'Please enter WhatsApp number';
  //     setErrors(newErrors);
  //   } else {
  //     const updatedNumbers = [...numbers, ''];
  //     setNumbers(updatedNumbers);
  //   }
  // };
  

  // const handleRemoveNumber = (index) => {
  //   const updatedNumbers = [...numbers];
  //   updatedNumbers.splice(index, 1);
  //   setNumbers(updatedNumbers);
  // };


    

  useEffect(() => {
    const fetchData = async () => {
      $('#loading').show();
      try {
        const accessToken = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
  
        if (!accessToken) {
          navigate('/');
          console.error('Access token not found in localStorage');
          $('#loading').hide();
          return;
        }
  
        const response = await fetch(`${baseURL}/get_accounts/`, {
          headers: {
            Authorization: `Token ${accessToken}`,
            'Cache-Control': 'no-cache', // Include access token in the headers
          },
        });
  
        const data = await response.json();
        if (data && data.data) {
          setBuilderTypes(data.data);
          $('#loading').hide();
        }
      } catch (error) {
        console.error('Error fetching builder types:', error);
        $('#loading').hide();
      }
    };
  
    fetchData();
  }, []);
  

  const handleBuilderTypeChange = (event) => {
    setSelectedBuilderType(event.target.value);
  };

  const handleSubmit = async (event) => {
    
    event.preventDefault();

    const newErrors = {};

if (!formData.builderName.trim()) {
  newErrors.builderName = 'Builder Name is required.';
}

if (!formData.facebookPageName.trim()) {
  newErrors.facebookPageName = 'Facebook Page Name is required.';
}

if (selectedBuilderType === '') {
  newErrors.selectedBuilderType = 'Account Username is required.';
}

if (!formData.adID.trim()) {
  newErrors.adID = 'Ad ID is required.';
}

if (!formData.whatsAppNumber.trim()) {
  newErrors.whatsAppNumber = 'WhatsApp Number is required.';
}

if (!formData.publishDate) {
  newErrors.publishDate = 'Publish Date is required.';
}
    
    //   setErrors(newErrors);
    // ... apply similar checks for other fields

    // If any errors are found, display them and prevent form submission
    if (Object.keys(newErrors).length > 0) {
        console.log("okaaaaaaaaayyyyyyyyy",newErrors)
      setErrors(newErrors);
      return;
    }

    const multipleNumberInputs = Array.from(event.target.getElementsByClassName('multiple-number-input'));
    const multipleNumbers = multipleNumberInputs
      .map((input) => input.value.trim())
      .filter((value) => value !== '');
    
      const whatsappNumbersObject = {};
      multipleNumbers.forEach((number, index) => {
        whatsappNumbersObject[`whats_app_no${index + 1}`] = number;
      });
      const multiplewhatsappno = JSON.stringify(whatsappNumbersObject); // Convert the object to a JSON string

  const formDataToSend  = {
    account_user: event.target.formBuilderType.value,
    builder_name: event.target.formBuilderName.value,
    facebook_page: event.target.formFacebookPageName.value,
    ad_id: event.target.formAdID.value,
    whats_app_number: event.target.formWhatsAppNumber.value,
    // Add other fields similarly
    multiple_numbers: multiplewhatsappno,
    published_date: event.target.formPublishDate.value,
  };

  console.log('FormData:', formDataToSend );
    
  
  try {
    $('#loading').show();
    const accessToken = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
  
    if (!accessToken) {
      navigate('/');
      console.error('Access token not found in localStorage');
      $('#loading').hide();
      return;
    }
  
    const response = await fetch(`${baseURL}/add_page/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${accessToken}`,
        'Cache-Control': 'no-cache', // Include access token in the headers
      },
      body: JSON.stringify(formDataToSend),
    });
  
    if (response.ok) {
      console.log('Form data sent successfully');
      $('#loading').hide();
      navigate('/home');
    } else {
      const errorData = await response.json(); // Assuming the server sends error details
      console.error('Failed to send form data', errorData);
      setErrors({});
      $('#loading').hide();
  
      // Update input errors based on the server response
      const newErrors = {};
  
      if (errorData && errorData.adID) {
        newErrors.adID = errorData.adID;
      }
  
      if (errorData && errorData.facebook_page) {
        newErrors.facebookPageName = errorData.facebook_page;
      }
  
      setErrors(newErrors);
    }
  } catch (error) {
    console.error('Fetch error:', error);
    $('#loading').hide();
  }
  
  
  };

  
  return (
    <div className="container-fluid tms-page">
      <div className="row flex-nowrap">
        <div className="col-auto p-0"><Sidebar /></div>
        <main className="tms-main">
          <div className="tms-page-header">
            <div>
              <h2 className="tms-page-title">Add Facebook Page</h2>
              <div className="tms-page-subtitle">Register a new ad campaign page</div>
            </div>
          </div>

          <div className="tms-card" style={{ maxWidth: 600 }}>
            <Form onSubmit={handleSubmit} disabled={loading}>

              {/* Account Username */}
              <div className="tms-form-group">
                <label className="tms-label">Account Username <span>*</span></label>
                <Form.Group controlId="formBuilderType">
                  <Form.Select
                    name="formBuilderType"
                    className={`tms-select${errors.selectedBuilderType ? ' tms-input-error' : ''}`}
                    value={selectedBuilderType}
                    onChange={handleBuilderTypeChange}
                  >
                    <option value="">Select Builder Type</option>
                    {Array.isArray(builderTypes) &&
                      builderTypes.map((type) => (
                        <option key={type.id} value={type.username}>
                          {type.username}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>
                {errors.selectedBuilderType && <div className="tms-error">{errors.selectedBuilderType}</div>}
              </div>

              {/* Builder Name */}
              <div className="tms-form-group">
                <label className="tms-label">Builder Name <span>*</span></label>
                <input
                  type="text"
                  id="formBuilderName"
                  name="formBuilderName"
                  placeholder="Enter builder name"
                  className={`tms-input${errors.builderName ? ' tms-input-error' : ''}`}
                  value={formData.builderName}
                  onChange={(e) => setFormData({ ...formData, builderName: e.target.value })}
                />
                {errors.builderName && <div className="tms-error">{errors.builderName}</div>}
              </div>

              {/* Facebook Page Name */}
              <div className="tms-form-group">
                <label className="tms-label">Facebook Page Name <span>*</span></label>
                <input
                  type="text"
                  id="formFacebookPageName"
                  name="formFacebookPageName"
                  placeholder="Enter Facebook page name"
                  className={`tms-input${errors.facebookPageName ? ' tms-input-error' : ''}`}
                  value={formData.facebookPageName}
                  onChange={(e) => setFormData({ ...formData, facebookPageName: e.target.value })}
                />
                {errors.facebookPageName && <div className="tms-error">{errors.facebookPageName}</div>}
              </div>

              {/* Ad ID */}
              <div className="tms-form-group">
                <label className="tms-label">Ad ID <span>*</span></label>
                <input
                  type="text"
                  id="formAdID"
                  name="formAdID"
                  placeholder="Enter Ad ID"
                  className={`tms-input${errors.adID ? ' tms-input-error' : ''}`}
                  value={formData.adID}
                  onChange={(e) => setFormData({ ...formData, adID: e.target.value })}
                />
                {errors.adID && <div className="tms-error">{errors.adID}</div>}
              </div>

              {/* WhatsApp Number */}
              <div className="tms-form-group">
                <label className="tms-label">WhatsApp Number <span>*</span></label>
                <input
                  type="text"
                  id="formWhatsAppNumber"
                  name="formWhatsAppNumber"
                  placeholder="Enter WhatsApp number"
                  className={`tms-input${errors.whatsAppNumber ? ' tms-input-error' : ''}`}
                  value={formData.whatsAppNumber}
                  onChange={(e) => setFormData({ ...formData, whatsAppNumber: e.target.value })}
                />
                {errors.whatsAppNumber && <div className="tms-error">{errors.whatsAppNumber}</div>}
              </div>

              {/* Toggle Add Number */}
              {!showForm && (
                <button type="button" className="tms-btn-secondary" onClick={toggleForm} style={{ marginBottom: 12 }}>
                  Add Number
                </button>
              )}

              {/* Multiple Numbers */}
              {showForm && (
                <div className="tms-form-group">
                  {numbers.map((number, index) => (
                    <div key={index} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                      <input
                        type="text"
                        placeholder={`Enter Number ${index + 1}`}
                        value={number}
                        onChange={(e) => {
                          const updatedNumbers = [...numbers];
                          updatedNumbers[index] = e.target.value;
                          setNumbers(updatedNumbers);
                        }}
                        className="tms-input multiple-number-input"
                        style={{ flex: 1 }}
                      />
                      <button
                        type="button"
                        className="tms-btn-danger"
                        onClick={() => handleRemoveNumber(index)}
                        disabled={numbers.length === 0}
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                  {numbers.length < 4 && (
                    <button type="button" className="tms-btn-secondary" onClick={handleAddNumber}>
                      Add Number
                    </button>
                  )}
                </div>
              )}

              {/* Publish Date */}
              <div className="tms-form-group">
                <label className="tms-label">Publish Date <span>*</span></label>
                <input
                  type="date"
                  id="formPublishDate"
                  name="formPublishDate"
                  className={`tms-input${errors.publishDate ? ' tms-input-error' : ''}`}
                  value={formData.publishDate}
                  onChange={(e) => setFormData({ ...formData, publishDate: e.target.value })}
                />
                {errors.publishDate && <div className="tms-error">{errors.publishDate}</div>}
              </div>

              <button type="submit" className="tms-btn-primary">Submit</button>
            </Form>
          </div>

          <div id="loading">
            <div className="loader">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="loader-text">Loading...</div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdAddPage;
